import { render, staticRenderFns } from "./BaseListContactsPage.vue?vue&type=template&id=6250080c&scoped=true&"
import script from "./BaseListContactsPage.vue?vue&type=script&lang=js&"
export * from "./BaseListContactsPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseListContactsPage.vue?vue&type=style&index=0&id=6250080c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6250080c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VLayout,VTab,VTabItem,VTabs})
